<template>
  <div class="sheet">
    <div v-show="leftConfig.bgShow">
      <div class="show-left-content-box" @click="exchangeCaseDo" v-show="showLeftIcon">
        <img :src="leftIconImg" />
      </div>
      <Transition name="slide-fade">
        <!-- :style="{width: rightConfig.leftWidth}" -->
        <div class="right-content-box left-content-box" v-show="leftConfig.isShow" :style="{width: rightConfig.leftWidth}">
          <div class="left-box" v-for="model in leftCaseTitleList" :key="model">
            <div class="resetBtn" @click="resetCaseAllDo(model)">
              <img src="@/assets/reset-high-icon.png" />
            </div> 
            <!-- <el-tooltip effect="light" v-for="item in model.list" :content="item.name" :disabled="true"  placement="right" :key="item" > -->
              <el-button class="left-btn" v-for="item in model.list" :style="btnStyle(item)" :key="item" @dblclick="doubleSelectCaseDo(item, model)" @click="singleSelectCaseDo(item, model)">{{ item.name }}</el-button>
            <!-- </el-tooltip>       -->
          </div>
        </div>
      </Transition>
    </div>
    <div v-show="rightConfig.bgShow">
      <div class="show-right-content-box" @click="exchangeDo" v-show="showRightIcon">
        <img :src="iconImg" />
      </div>
      <Transition name="slide-fade">
        <div class="right-content-box" v-show="rightConfig.isShow" :style="{width: rightConfig.leftWidth}">
          <div class="left-box" v-for="caseModel in caseTitleList" :key="caseModel">
            <div class="resetBtn" @click="resetAllDo(caseModel)">
              <img src="@/assets/reset-high-icon.png" />
            </div> 
            <!-- <el-tooltip effect="light" v-for="item in caseModel.list" :content="item.name" :disabled="!item.showTip" placement="left" :key="item" > -->
              <el-button class="left-btn" v-for="item in caseModel.list" :key="item" :style="btnStyle(item)" @click="selectTitleDo(item, caseModel)">{{ item.name }}</el-button>
            <!-- </el-tooltip>       -->
          </div>
        </div>
      </Transition>
    </div>
    <!-- :style="{marginRight: rightConfig.bgMarginLeft}" -->
    <div class="bg" id="sheet" ref="refBg" >
      <Transition name="top-fade">
        <div class="top-content" id="top-content" v-show="isFold">
          <LayInfo :userModel="userModel" @longDo="longDo" @shortDo="shortDo" :isCanEdite="isCanEdite" class="layInfo">
            <template #collection>
              <section class="check_bg_box">
                <el-checkbox v-for="item in checkList" v-model="item.selected" :key="item" class="check-box"
                  @change="checkChange(item)" :disabled="!isCanEdite">{{ item.title }}</el-checkbox>
              </section>
            </template>
          </LayInfo>
          <LayAnnotationList :annotationList="annotationList" @mouseOutInput="mouseOutInput" @addItem="addItem"
            @deleteDo="deleteDo" :isCanEdite="isCanEdite">
          </LayAnnotationList>
          <div class="status-box" v-show="showStatusBox">
            <div class="status-time status-font">{{ sheetStatusModel.time }}</div>
            <div :class="showCancel ? 'cancel-status-start status-font' : 'status-start status-font'">{{
              sheetStatusModel.start
            }}</div>
            <div class="status-line"></div>
            <div :class="showCancel ? 'cancel-status-finish status-font' : 'status-finish status-font'">{{
              sheetStatusModel.finish }}</div>
            <div class="status-title" :style="{ backgroundColor: getStatusMap(sheetStatusModel.currentState).bgColor }"
              v-show="showStatus">
              {{ getStatusMap(sheetStatusModel.currentState).title }}
            </div>
            <el-button v-show="showCancel" class="cancelBtn" @click="cancelTrialDo">Cancel</el-button>
          </div>
        </div>
      </Transition>
      <div class="info-bootom-box" @click="foldClickDo">
        <div class="info-bootom-title">{{ getBottomTitle() }}</div>
        <img :src="getBottomImg()" />
      </div>
      <div class="tableBg" ref="tableBg" id="tableBg" v-show="trialsList.length > 0" >
        <el-table element-loading-background="rgba(255, 255, 255, 0.8)" v-loading="loading" class="table" id="table"
          :data="dataList" ref="dragTable"  stripe lazy
          tooltip-effect="light" border fit :header-cell-style="{borderColor: '#999999'}" 
          :cell-style="{background: '#FFFFFF',borderColor: '#999999',}" :height="tableH" scrollbar-always-on>
          <el-table-column fixed align="center" :width="trialMaxWidth">
            <template #header>
              <div class="header-box" :style="{minHeight: maxHeaderLineH}" v-show="originDataList.length > 0" >
                <div class="header-box-top">
                  <img class="header-trial-img" src="@/assets/add-trial-icon.png" @click="addTrialListDo"
                    v-show="isCanEdite" />
                  <div class="header-title header-trial">trial</div>
                </div>
                <div class="header-box-bottom" v-show="originDataList.length > 1">
                  <SearchTool ref="searchTool" @searchKeyWords="searchKeyWords"></SearchTool>
                </div>
              </div>
            </template>
            <template #default="scope">
              <div class="trial-bg">
                <span class="trial-no">{{ scope.$index + 1 }}</span>
                <el-checkbox class="table-trial-checkbox" @mousedown="mouseDownCheckBox"
                  @mouseover="mouseOverCheckBox(scope.row)" v-model="scope.row.isSelected"
                  v-show="isCanEdite"></el-checkbox>
                <div class="table-trial" :style="{color: scope.row?.titleColor}" @click="pushPage(scope.row)">
                  {{ scope.row.name }}
                </div>
                <!-- <div class="line"></div> -->
              </div>
            </template>
          </el-table-column>
          <!-- :width="getColumnWidth(ind)" -->
          <el-table-column align="center" v-for="(item, ind) in columnsTitleList" :key="item" :min-width="item.width" :width="getColumnWidth(ind)">
            <template #header>
              <div class="header-bg" :style="{minHeight: maxHeaderLineH}" v-show="originDataList.length > 0">
                <div class="header-title" @mousedown="longPress(item)" @mouseup="cancelLongPress(item, true)" @mousemove="mouseMove">{{ item.showName }}</div>                
                <div class="line" ref="line" @mouseover="mouseover" @mouseenter="moveLineEnter(ind)"
                  @mouseleave="moveLineLive" v-show="isCanEdite"></div>
              </div>
            </template>
            <template #default="scope" >
              <div>
                <div :class="ind == 1 ? 'content-bg dur-content-bg' : 'content-bg'" :style="{
                    backgroundColor: scope.row[item?.name]?.trialColor,
                  }">
                  <div :class="ind == 0 ? 'table-status' : 'table-content'" @click.right="openReport(scope.row, item)" :style="{
                    backgroundColor: scope.row[item?.name]?.bgColor,
                  }">
                    {{ scope.row[item?.name]?.value }}
                  </div>
                </div> 
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <img class="delete-trial-icon" id="divId" src="@/assets/delete-trial-icon.png" @click="deleteTrialDo"
        v-show="showDeleteIcon" />
      <div class="add-line-bg" id="addLineBg" v-show="showAddColumnIcon" @mouseleave="mouseLeaveAddLineBg" @mouseenter="mouseEnterAddLineBg">
        <img class="add-icon" src="@/assets/add-clounm-icon.png" @click="addColumDo" />
        <div class="add-line" :style="{ height: lineHeight }"></div>
      </div>
      <TrailListDialog :dialogVisible="dialogVisible" :allDataList="allSelectDataList" :totalCount="sheetPage.totalCount" :loading="sheetPage.loading" @changePage="changePage" @cancelDo="trialDismissDo"
        @confirmDo="trialConfirmDo" @checkTrialDo="checkTrialDo"></TrailListDialog>
      <AddFieldNameDialog @cancelDo="cancelDo" @confirmDo="fieldNameConfirmDo" :dialogVisible="fieldNameFieldVisible">
      </AddFieldNameDialog>
      <PublishDialog :dialogVisible="publishDialogVisible" @cancelDo="cancelDo" @publishSubmitDo="publishSubmitDo"
        :model="publishModel"></PublishDialog>
      <UniversalPopover :dialogVisible="popoverDialogVisible" :title="dialogTitle" @cancelDo="popoverCancelDo"
        @comfirmDo="comfirmDo"></UniversalPopover>
      <UniversalPopover :dialogVisible="showDeleteTitleVisible" :title="deleteTrialTitle" :bright-title="deleteTrialBrightTitle" :nomarl-confirm="false" @cancelDo="cancelDo"
        @comfirmDo="deleteTitlecomfirmDo"></UniversalPopover>
      <TrialCancelledListDialog :dialog-visible="cancelDialogModel.dialogVisible" :all-data-list="cancelDialogModel.list" @cancelDo="cancelDo"></TrialCancelledListDialog>
      <!-- <div class="tool-tip" :style="tipStyle">testudsadasdhkhsa</div> -->
    </div>
  </div>
</template>
<script>
import {
  getQueryStatus,
  getQueryMetricsBySheet,
  getPageUserByUserId,
  updateAnnotation,
  markLongLive,
  updateTrialSheet,
  queryResourcesList,
  markPublish,
  addTag,
  cancelTrialsBySheet
} from "@/request/api";

import {
  ResourceType,
  RunnerStatus,
} from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
import LayInfo from "@/components/LayInfo.vue";
import LayAnnotationList from "@/components/LayAnnotationList.vue";
import TrailListDialog from "@/components/TrailListDialog.vue";
import AddFieldNameDialog from "@/components/AddFieldNameDialog.vue";
import PublishDialog from "@/components/PublishDialog.vue";
import UniversalPopover from "@/components/UniversalPopover.vue";
import TrialCancelledListDialog from "@/components/TrialCancelledListDialog.vue";
import SearchTool from "@/components/SearchTool.vue";
import { formatTimeToHMS, formatTimeTo2HMS, getStrWidthBySpan } from "@/utils/common";
import moment from "moment";
const SETTIMEOUT = 200
const MAX_LEFT_BTN_WIDTH = 150
const MIN_LEFT_BTN_WIDTH = 60
const COLUMNS_LEN = 20
export default {
  name: "sheet",
  data() {
    return {
      publishDialogVisible: false,
      popoverDialogVisible: false,
      deleteTrialTitle: "",
      deleteTrialBrightTitle: "",
      showDeleteTitleVisible: false,
      dialogVisible: false,
      fieldNameFieldVisible: false,
      lineHeight: 0,
      trialsList: [],
      loading: true,
      dataList: [],
      userModel: {
        name: "",
        time: "",
        type: 0,
      },
      trialMaxWidth: 230,
      tableH: 60,
      oriTableH: 0,
      annotationList: [],
      resourceId: "",
      isInputing: false,
      allSelectDataList: [],
      moveOverItem: {},
      deleteTrialList: [],
      showAddColumnIcon: false,
      addColumnIndex: 0,
      isCanEdite: false,
      publishStyle: {
        backgroundColor: "#0052D9",
        color: "#ffffff",
      },
      publishModel: {
        tool: "",
        verison: "",
        description: "",
      },
      published: false,
      clickName: "",
      showCancel: false,
      sheetStatusModel: {
        time: "-",
        start: "",
        finish: "-",
        status: "",
        bgColor: "",
        currentState: null,
        runState: null,
        hasRunning: false,
        hasCancel: false,
      },
      dialogTitle: "Do you want to cancel trial ?",
      showStatusBox: false,
      checkList: this.$DataString?.tagList,
      tagMsg: "",
      tagsTitle: [],
      originTrialsList: [],
      maxTime: null,
      minTime: null,
      selectTrialItem: {},
      isAsc: true, //升序
      longTimer: null,
      addTimer: null,
      deleteItem: {},
      sheetPage: {
        pageNumber: 1,
        pageSize: 8,
        list: [],
        totalCount: 0,
        loading: false,
      },
      addTrialsList: [],
      cancelDialogModel: {
        dialogVisible: false,
        list: []
      },
      isFold: false,
      maxHeaderLineH: '0px',
      leftCaseTitleList: [],
      caseTitleList:[],
      originDataList: [],
      leftFilterDataList: [],
      columnsTitleList: [],
      originColumnsTitleList: [],
      scrollColumnsTitleList: [],
      leftConfig: {
        isShow: false,
        bgShow: true
      },
      rightConfig: {
        disabled: false,
        isShow: false,
        leftWidth: '',
        bgMarginLeft: '',
        bgLeft: 0,
        bgShow: true
      },
      doubleConfig: {
        clickNum: 0,
        doubleTimer: null,
      },
      leaveTimer: null,  
      tipStyle: {
        right: '50px',
        top: '200px',
      },
      searchDataList: [], 
      showLeftIcon: false,
    };
  },
  components: {
    LayInfo,
    LayAnnotationList,
    TrailListDialog,
    AddFieldNameDialog,
    PublishDialog,
    UniversalPopover,
    TrialCancelledListDialog,
    SearchTool
  },
  computed: {
    showRightIcon() {
      return this.columnsTitleList.length > 2
    },
    iconImg() {
      return this.rightConfig.isShow ? require('../assets/yincang-icon-1.png') : require('../assets/zhanshi-icon.png')
    },
    leftIconImg() {
      return this.leftConfig.isShow ? require('../assets/yincang-icon.png') : require('../assets/zhanshi-icon.png')
    },
    showDeleteIcon() {
      return this.dataList.some((m) => {
        return m.isSelected == true;
      });
    },
    publishColor() {
      return this.published ? "#ffffff" : "#A6A6A6";
    },
    publishBgColor() {
      return this.published ? "#0052D9" : "#F5F5F5";
    },
    showStatus() {
      return this.sheetStatusModel.hasRunning
    },
    comfirmDisable() {
      const isDisable = this.caseTitleList.some(m1 => {
        const have = m1.list.some(m2 => {
          return m2.selected == true;
        })
        return have
      })
      return !isDisable
    },
    btnStyle() {
      return function (model) {
        const style = {
          color: "#565656",
          backgroundColor: "#fff",
          minWidth: `${model.width}px`,
          maxWidth: `${MAX_LEFT_BTN_WIDTH}px`
        }
        if (model.selected) {
          style.color = "#fff"
          style.backgroundColor = "#0052D9"
        } 
        return style;
      };
    },
    haveSelected() {
      return function (model) {
        const isHave = model.list.some(mod => {
          return mod.selected == true
        })
        return isHave;
      };
    },
    columnItemList() {
      //getColumnTrialColor
      return function (item, metricsList) {
        const list = metricsList?.filter(m => {
          return m.name == item.name
        })
        const model = list?.shift()
        return [model]//model?.trialColor
      };
    },
  },

  mounted() {
    const _this = this
    window.onresize = () => {
      return (() => {
        _this.loadBgLayout()
      })()
    }
  },
  methods: {
    openReport(trial, item) {
      const trialName = trial.name
      const trialId = trial.trialid
      const name = item.name
      // const field = item.field
      const source = item.source
      if (source != 1) {
        const routeData = this.$router.resolve({name: "SheetReport", params: {trialName: trialName, columnName: name, trialId: trialId}})
        window.open(routeData.href, "_blank");
      }
    },
    searchKeyWords(keyWords) {
      const regExp = new RegExp(keyWords,  'i')    
      const arrList = this.searchDataList
      const regexpList = arrList.filter(model => {
        return model?.name?.search(regExp) != -1
      })
      this.dataList = regexpList
      // this.searchDataList = regexpList
      // if (keyWords) {
      this.getTableHeight()
      // } else {
      //   this.tableH = this.oriTableH
      // }
    },
    getTableHeight() {
      const headerH = parseFloat(this.maxHeaderLineH.split('px').shift())
      const bottomScrollBarH = 18
      const rowH = 50//55
      const lineH = 1
      const count = this.dataList.length
      const totalH =  count * (rowH + lineH) + headerH + bottomScrollBarH      
      const tableBoxTop = this.$refs.tableBg.offsetTop
      const clientHeight = document.body.clientHeight
      const hei = clientHeight - tableBoxTop - 102 - 13

      this.tableH = totalH > hei ? hei : totalH
      if (this.tableH < (headerH + 80)) {
        this.tableH = headerH + 80
      }
      if (this.oriTableH == 0) {
        this.oriTableH = this.tableH
      }
    },
    getColumnWidth(ind) {
      let width = 0
      if (ind == 0) {
        width = 110
      } else if (ind == 1) {
        width = 85
      }
      return width
    },
    exchangeCaseDo() {
      this.leftConfig.isShow = !this.leftConfig.isShow
    },
    exchangeDo() {
      this.rightConfig.isShow = !this.rightConfig.isShow
      // const _this = this;
      // setTimeout(() => {
      //   _this.loadBgLayout()
      // }, SETTIMEOUT)
    },
    filterCaseDataListDo() {
      this.$refs.searchTool.keyWords = ""
      let lastIndex = 0
      let haveSelected = false
      let newOriginDataList = [...this.originDataList]//JSON.parse(JSON.stringify(this.originDataList))

      for (const index in this.leftCaseTitleList) {
        const model = this.leftCaseTitleList[index];
        model.selected = false
        const isSelect = model.list.some(m => {
          return m.selected == true
        })
        if (isSelect) {
          lastIndex = index
          haveSelected = isSelect
          model.selected = isSelect
        }
      }

      if (haveSelected) {
        for (const index in this.leftCaseTitleList) {
          const caseItem = this.leftCaseTitleList[index]
          const list = caseItem.list
          const newCaseList = []
          
          if (index < lastIndex) {
            if (caseItem.selected) {
              for (const nItem of newOriginDataList) {
                const clList = nItem.list
                const str = clList[index]
                const isHave = list.some(m => {
                  return m.selected == true && m.name == str
                })
                if (isHave) {
                  newCaseList.push(nItem)
                } 
              }
              if (newCaseList.length > 0) {
                newOriginDataList = newCaseList
              }
            } else {
              for (const nItem of newOriginDataList) {
                newCaseList.push(nItem)
              }
              if (newCaseList.length > 0) {
                newOriginDataList = newCaseList
              }
            }
          } 
          else if (index == lastIndex) {
            for (const nItem of newOriginDataList) {
              const clList = nItem.list
              const str = clList[index]
              if (str) {
                const isHave = list.some(m => {
                  return m.selected == true && m.name == str
                })
                if (isHave) {
                  newCaseList.push(nItem)
                } 
              } else {
                newCaseList.push(nItem)
              }
            }
            if (newCaseList.length > 0) {
              newOriginDataList = newCaseList
            }
          }
        }
      }
      this.dataList = newOriginDataList
      this.searchDataList = [...newOriginDataList]
      this.getTableHeight()
    },
    singleSelectCaseDo(item, model) {
      clearTimeout(this.doubleConfig.doubleTimer)
      this.doubleConfig.doubleTimer = null
      const _this = this
      this.doubleConfig.doubleTimer = setTimeout(() => {
        // model.selected = !model.selected
        item.selected = !item.selected
        if (item.selected) {
          model.list.map(m => {
            if (m.name != item.name) {
              m.selected = false
            }
          })
        }
        setTimeout(() => {
          _this.filterCaseDataListDo()
        }, SETTIMEOUT)
        clearTimeout(_this.doubleConfig.doubleTimer)
         _this.doubleConfig.doubleTimer = null
      }, 300);
    },
    
    doubleSelectCaseDo(item, model) {
      console.log(model)
      clearTimeout(this.doubleConfig.doubleTimer)
      this.doubleConfig.doubleTimer = null
      item.selected = !item.selected
      const _this = this
      setTimeout(() => {
        _this.filterCaseDataListDo()
      }, SETTIMEOUT)
    },
    async caseConfirmDo() {
      // this.dataList = this.searchDataList
      this.scrollColumnsTitleList = [...this.originColumnsTitleList]//JSON.parse(JSON.stringify(this.originColumnsTitleList))
      let haveSelected = false
      let lastIndex = 0
      for (const index in this.caseTitleList) {
        const caseModel = this.caseTitleList[index];
        caseModel.isSelected = false
        const isSelect = caseModel.list.some(m => {
          return m.selected == true
        })
        if (isSelect) {
          lastIndex = index
          haveSelected = isSelect
          caseModel.isSelected = isSelect
        }
      }
      
      // let isMore = false
      if (haveSelected) {
        for (const index in this.caseTitleList) {
          const caseItem = this.caseTitleList[index]
          const list = caseItem.list
          const newColumnsList = []
          
          if (index < lastIndex) {
            if (caseItem.isSelected) {
              for (const columnItem of this.scrollColumnsTitleList) {
                const clList = columnItem.list
                const str = clList[index]
                const isHave = list.some(m => {
                  return m.selected == true && m.name == str
                })
                if (isHave) {
                  newColumnsList.push(columnItem)
                } 
              }
              if (newColumnsList.length > 0) {
                this.scrollColumnsTitleList = newColumnsList
              }
            } else {
              for (const columnItem of this.scrollColumnsTitleList) {
                newColumnsList.push(columnItem)
              }
              if (newColumnsList.length > 0) {
                this.scrollColumnsTitleList = newColumnsList
              }
            }

          } 
          else if (index == lastIndex) {
            for (const columnItem of this.scrollColumnsTitleList) {
              const clList = columnItem.list
              const str = clList[index]
              if (str) {
                const isHave = list.some(m => {
                  return m.selected == true && m.name == str
                })
                if (isHave) {
                  newColumnsList.push(columnItem)
                } 
              } else {
                newColumnsList.push(columnItem)
              }
            }
            if (newColumnsList.length > 0) {
              this.scrollColumnsTitleList = newColumnsList
            }
          }
        }
        const haveDur = this.scrollColumnsTitleList.some(m => {
          return m.name == "Duration"
        })
        if (!haveDur) {
          const durationModel = {
            name: "Duration",
            field: "Duration",
            showName: "Duration",
            bgColor: "#ffffff",
            source: 1,
          };
          this.scrollColumnsTitleList.unshift(durationModel);
        }

        const haveStat = this.scrollColumnsTitleList.some(m => {
          return m.name == "Status"
        })
        if (!haveStat) {
          const statusModel = {
            name: "Status",
            field: "Status",
            showName: "Status",
            bgColor: "#ffffff",
            source: 1,
          };
          this.scrollColumnsTitleList.unshift(statusModel);
        }
      }
      if (this.scrollColumnsTitleList.length > COLUMNS_LEN) {
        this.columnsTitleList = this.scrollColumnsTitleList.slice(0, COLUMNS_LEN)
      } else {
        this.columnsTitleList = this.scrollColumnsTitleList
      }
    },
    resetCaseAllDo(model) {
      for (const m of model.list) {
        m.selected = false;
      }
      const _this = this;
      setTimeout(() => {
        _this.filterCaseDataListDo()
      }, SETTIMEOUT)
    },
    resetAllDo(caseModel) {
      for (const m of caseModel.list) {
        m.selected = false;
      }
      const _this = this;
      setTimeout(() => {
        _this.caseConfirmDo()
      }, SETTIMEOUT)
    },
    selectTitleDo(item, caseModel) {
      const _this = this;
      this.doubleConfig.clickNum ++
      if (this.doubleConfig.doubleTimer) {
        return
      }
      this.doubleConfig.doubleTimer = setTimeout(() => {
        if (_this.doubleConfig.clickNum >= 2) {
          item.selected = !item.selected
        } else {
          item.selected = !item.selected
          if (item.selected) {
            caseModel.list.map(m => {
              if (m.name != item.name) {
                m.selected = false
              }
            })
          }
        }
        _this.doubleConfig.clickNum = 0
        _this.doubleConfig.doubleTimer = null
        setTimeout(() => {
          _this.caseConfirmDo()
        }, SETTIMEOUT)
      }, SETTIMEOUT);
    },
    foldClickDo() {
      const topContent1 = document.getElementById("top-content");
      const hei = topContent1.offsetHeight
      this.isFold = !this.isFold
      if (this.isFold && this.rightConfig.isShow || !this.isFold && !this.rightConfig.isShow) {
        this.rightConfig.isShow = !this.rightConfig.isShow
      } 
      if (this.isFold && this.leftConfig.isShow || !this.isFold && !this.leftConfig.isShow) {
        if (this.trialsList.length >= 2) {
          this.leftConfig.isShow = !this.leftConfig.isShow
        } 
      } 
      
      const _this= this
      setTimeout(() => {
        const d = document.getElementById("divId");
        const topContent = document.getElementById("top-content");
        let topCH = topContent.offsetHeight
        if (topContent.offsetHeight == 0) {
          topCH = hei
        }
        const top = parseFloat(d.style.top.split('px')[0])
        if (_this.isFold) {
          d.style.top = top + topCH + 60 + "px";
        } else {
          d.style.top = top - topCH - 60 + "px";
        }
      }, 200);
    },
    getBottomImg() {
      return this.isFold ? require("@/assets/sheet-fold-icon.png") : require("@/assets/sheet-more-icon.png")
    },
    getBottomTitle() {
      return this.isFold ? "FOLD" : "MORE"
    },
    getColumnTrialColor(item, metricsList) {
      const list = metricsList.filter(m => {
        return m.name == item.name
      })
      const model = list.shift()
     return model?.trialColor
    },
    longPress(item) {      
      this.longTimer = null;
      this.longTimer = setTimeout(() => {
        this.deleteItem = item
        clearTimeout(this.longTimer)   
        this.longTimer = null;       
        if (item.source != 1) { 
          this.deleteTrialTitle = `are you sure to delete`
          this.deleteTrialBrightTitle = item.name
          this.showDeleteTitleVisible = true;
        } else {
          this.$message.warning(`"${item.name}" cannot be deleted`)
        }
      }, 1000);
    },
    cancelLongPress(item, isClick) {
      clearTimeout(this.longTimer)
      if (this.longTimer) {
        this.sortClick(item, isClick)
      }
      this.longTimer = null
    },
    async deleteTitlecomfirmDo() {
      let noamrlList = this.originColumnsTitleList.filter((m) => {
        return m?.source == 1;
      });
      let newList = this.originColumnsTitleList.filter((m) => {
        return m?.source != 1;
      });
      newList = newList.filter((m) => {
        return m?.name != this.deleteItem.name;
      });
      this.originColumnsTitleList = noamrlList.concat(newList)
      console.log(newList);
      await updateTrialSheet({
        sheetId: this.resourceId,
        rowsList: this.trialsList,
        columnsList: newList,
      });

      const scrollNewList = this.scrollColumnsTitleList.filter((m) => {
        return m?.name != this.deleteItem.name;
      });
      this.scrollColumnsTitleList = scrollNewList

      this.columnsTitleList = this.columnsTitleList.filter(m => {
        return m.name != this.deleteItem.name
      })
      this.showDeleteTitleVisible = false;
    },
    checkChange(item) {
      if (item.selected) {
        this.tagMsg = `Successfully selected ${item.title}`
      } else {
        this.tagMsg = `Successfully cancelled ${item.title}`
      }
      this.tagsTitle = [];
      this.checkList.forEach(m => {
        if (m.selected) {
          this.tagsTitle.push(m.title)
        }
      })
      this.collectionDo()
    },
    async collectionDo() {
      try {
        const dd = await addTag({ sheetId: this.resourceId, type: ResourceType.SHEET, tags: this.tagsTitle })
        console.log(dd);
        this.$message.success(this.tagMsg)
      } catch (error) {
        console.log(error)
      }
    },
    cancelTrialDo() {
      this.popoverDialogVisible = true;
    },
    getTitleWidth(index, item) {
      if (index == 0) {
        return 160;
      } else {
        if (item.name == "Operate") {
          return 120;
        }
      }
      return 0;
    },
    sortClick(item, isClick) {
      this.selectTrialItem = item;
      const l1 = this.dataList.filter(m1 => {
        const v1 = m1[item.name]
        return v1?.sortValue != "" && v1?.sortValue != "/"
      })
     
      const l2 = this.dataList.filter(m1 => {
        const v1 = m1[item.name]
        return v1?.sortValue == "/" || v1?.sortValue == ""
      })
      if (isClick) {
        if (item.name == this.clickName) {
          this.isAsc = true
          this.clickName = "";
        } else {
          this.isAsc = false;
          this.clickName = item.name;
        }
      }
      if (this.isAsc) {
        l1.sort((m1, m2) => {
          const v1 = m1[item.name];
          const v2 = m2[item.name];
          if (!Number.isNaN(parseFloat(v2?.sortValue)) && !Number.isNaN(parseFloat(v1?.sortValue))) {
            return parseFloat(v2?.sortValue) - parseFloat(v1?.sortValue);
          } 
          return `${v1?.sortValue}`.toLocaleLowerCase().localeCompare(`${v2?.sortValue}`.toLocaleLowerCase());
        });
      } else {
        l1.sort((m1, m2) => {
          const v1 = m1[item.name];
          const v2 = m2[item.name];
          if (!Number.isNaN(parseFloat(v1?.sortValue)) && !Number.isNaN(parseFloat(v2?.sortValue))) {
            return parseFloat(v1?.sortValue) - parseFloat(v2?.sortValue);
          } 
          return `${v2?.sortValue}`.toLocaleLowerCase().localeCompare(`${v1?.sortValue}`.toLocaleLowerCase());
        });
      }

      this.dataList = l1.concat(l2)
      this.tableLayout();
    },
    async publishSubmitDo(item) {
      this.publishDialogVisible = false;

      for (const key in item) {
        const arr = this.annotationList.filter((m) => {
          return m.keyWord == key;
        });
        if (arr?.length > 0) {
          const model = arr[0];
          model.keyValue = item[`${key}`];
        } else {
          const model = {
            keyWord: key,
            keyValue: item[`${key}`],
            isSelected: false,
            img: require("@/assets/data-normal-icon.png"),
          };
          this.annotationList.push(model);
        }
      }
      const model = {
        resourceId: this.resourceId,
        type: ResourceType.SHEET,
        list: this.annotationList,
        publish: true,
      };
      await markPublish(model);
      this.$message.success("markPublish successfully");
      this.published = !this.published;
    },
    async publishClick() {
      console.log("publishClick");
      if (this.published) {
        const model = {
          resourceId: this.resourceId,
          type: ResourceType.SHEET,
          list: this.annotationList,
          publish: false,
        };
        await markPublish(model);
        this.$message.success("markPublish successfully");
        this.published = !this.published;
      } else {
        this.publishDialogVisible = true;
      }
    },
    getStatusBgColor(item, metricsList) {
      const list = metricsList.filter(m => {
        return m.name == item.name
      })
      const model = list.shift()
      return model?.bgColor;
    },
    // 根据表格列内容里最长的一个设宽度
    flexColumnWidth(item, index) {
      if (index == 0) {
        return 110;
      } else if (index == 1) {
        return 85
      }
      return 90;
      // // console.log("item ====== ", item)
      // let maxWidth = 0
      // for (const model of this.dataList) {
      //   // const list = model.metricsList?.filter(m => {
      //   //   return m.name == item.name
      //   // })
      //   // const mm = list?.shift()
      //   const mm = model[item.name]
      //   if (mm?.value) {
      //     const str = `${mm?.value}`
      //     const width = getStrWidthBySpan(str, 13, 600) + 10
      //     maxWidth = width > maxWidth ? width : maxWidth;
      //   }
      // }
      // maxWidth = maxWidth + 5;
      // return maxWidth
    },
    //根据表头label设表格列宽度
    flexRowWidth(list) {
      let maxWidth = 0
      for (const index in list) {
        const item = list[index]
        const str = `${index} ${item?.name}`;
        const flexWidth = getStrWidthBySpan(str, 14, 600) 
        if (flexWidth >= maxWidth) {
          maxWidth = flexWidth;
        }
      }
      maxWidth = maxWidth > 150 ? maxWidth : 150;
      let w = 75;
      if (!this.isCanEdite) {
        w = 40;
      }
      maxWidth = maxWidth + w
      if (maxWidth >= this.trialMaxWidth) {
        this.trialMaxWidth = maxWidth
      }
    },
    addColumDo() {
      this.showAddColumnIcon = false;
      this.fieldNameFieldVisible = true;
    },
    async addTrialListDo() {
      if (this.allSelectDataList.length == 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        await this.getTrailListData();
        loading.close()
      }
      this.dialogVisible = true;
    },
    async fieldNameConfirmDo(item) {
      this.cancelDo()
      const isHave = this.originColumnsTitleList.some((m) => {
        return m?.name?.toLowerCase() == item.name.toLowerCase();
      });
      if (isHave) {
        this.$message.warning(`trial already have this ${item.name}`);
        return true;
      }
      let newList = [...this.originColumnsTitleList]
      newList.splice(this.addColumnIndex + 1, 0, item);
      newList = newList.filter((m) => {
        return m?.source != 1;
      });
      await updateTrialSheet({
        sheetId: this.resourceId,
        rowsList: this.trialsList,
        columnsList: newList,
      });
      this.initData()
    },
    checkTrialDo(item) {
      if (item.isSelected) {
        this.addTrialsList.push(item)
      } else {
        const index = this.addTrialsList.indexOf(item)
        this.addTrialsList.splice(index, 1)
      }
    },
    async changePage(page) {
      this.sheetPage.pageNumber = page
      const list = this.allSelectDataList.filter(model => {
        return model.key == page
      })
      if (list.length == 0) {
        this.sheetPage.loading = true
        await this.getTrailListData()
        this.sheetPage.loading = false
      }
    },
    trialConfirmDo() {
      this.cancelDo()
      this.updateSheetList();
    },
    trialDismissDo() {
      this.addTrialsList.map(model => {
        model.isSelected = false
      })
      this.addTrialsList = []
      this.cancelDo()
    },
    cancelDo() {
      this.dialogVisible = false;
      this.fieldNameFieldVisible = false;
      this.publishDialogVisible = false;
      this.popoverDialogVisible = false;
      this.showDeleteTitleVisible = false;
      this.cancelDialogModel.dialogVisible = false;
    },
    popoverCancelDo() {
      this.popoverDialogVisible = false
    },
    async comfirmDo() {
      this.popoverDialogVisible = false;
      const id = this.$route.params.id
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        const rowList = await cancelTrialsBySheet(id);
        this.cancelDialogModel.list = rowList
        loading.close()
      } catch (error) {
        loading.close()
      }
      this.cancelDialogModel.dialogVisible = true;
      await this.initData();
    },
    mouseoutHeader() {
      this.isInputing = false;
    },
    headerEnter() {
      this.isInputing = true;
    },
    changeDo(index, model) {
      console.log("index = ", index);
      console.log("model = ", model);
      for (const item of this.dataList) {
        item.metricsList.forEach((mm) => {
          if (mm.field == model.field) {
            mm.name = model.name;
          }
        });
      }
    },
    addTrialDo() {
      this.dialogVisible = true;
      this.getTrailListData();
    },
    async updateSheetList() {
      for (const sheet of this.addTrialsList) {
        const item = {
          name: sheet.title,
          trialid: sheet.trialid,
          isSelected: false,
        };
        this.trialsList.push(item);
      }
      const newList = this.originColumnsTitleList.filter((m) => {
        return m?.source != 1;
      });
      await updateTrialSheet({
        sheetId: this.resourceId,
        rowsList: this.trialsList,
        columnsList: newList,
      });
      this.addTrialsList.map(sheet => {
        sheet.disabled = sheet.isSelected
      })
      this.addTrialsList = []
      this.initData()
      this.tableLayout();
    },
    async deleteTrialDo() {
      const deleteList = this.dataList.filter(m => {
        return m.isSelected == true;
      })
      const list = this.trialsList.filter((m) => {
        const ha = deleteList.some(de => {
          return de.trialid == m.trialid
        })
        return !ha;
      });
      this.trialsList = list
      const newList = this.originColumnsTitleList.filter((m) => {
        return m?.source != 1;
      });
      console.log(newList);
      await updateTrialSheet({
        sheetId: this.resourceId,
        rowsList: this.trialsList,
        columnsList: newList,
      });
      const list1 = this.dataList.filter(m => {
        return m.isSelected != true;
      })
      this.dataList = list1;
    },
    mouseOverCheckBox(item) {
      this.moveOverItem = item;
    },
    mouseDownCheckBox(e) {
      if (!this.moveOverItem.isSelected) {
        const d = document.getElementById("divId");
        const tableBg = document.getElementById("tableBg");
        d.style.left = tableBg.offsetLeft - 40 + "px";
        d.style.top = e.pageY - 102 + "px";
      }
    },
    mouseLeaveAddLineBg() {
      this.showAddColumnIcon = false;
    },
    mouseEnterAddLineBg() {
      clearTimeout(this.leaveTimer)
      this.leaveTimer = null;
    },
    mouseover(e) {
      clearTimeout(this.addTimer)
      this.addTimer = null;
      const _this = this
      this.addTimer = setTimeout(() => {
        _this.showAddColumnIcon = true;
        const tableBg = document.getElementById("tableBg");
        const addLineBg = document.getElementById("addLineBg");
        addLineBg.style.left = e.pageX - 16 + "px";
        addLineBg.style.top = tableBg.offsetTop - 44 + "px";
        // _this.lineHeight =  tableBg.offsetHeight - 44 + "px"
      }, 300)
    },
    moveLineLive() {
      clearTimeout(this.addTimer)
      this.addTimer = null;
      const _this = this
      this.leaveTimer = setTimeout(() => {
        _this.showAddColumnIcon = false
      }, 1000)
    },
    moveLineEnter(index) {
      this.addColumnIndex = index;
    },
    mouseMove() {
      this.showDeleteTitleVisible = false;
    },
    deleteDo() {
      this.updateAnnotationData();
    },
    addItem() {
      // this.updateAnnotationData()
      console.log("addItem");
    },
    async updateAnnotationData() {
      await updateAnnotation({
        resourceId: this.resourceId,
        type: ResourceType.SHEET,
        list: this.annotationList,
      });
    },
    mouseOutInput() {
      console.log("mouseOutInput");
      this.updateAnnotationData();
    },
    async longDo() {
      this.userModel.type = 1;
      this.updateLongLive({
        longLive: true,
        resourceId: this.resourceId,
        type: ResourceType.SHEET,
      });
    },
    async shortDo() {
      this.userModel.type = 0;
      this.updateLongLive({
        longLive: false,
        resourceId: this.resourceId,
        type: ResourceType.SHEET,
      });
    },
    async updateLongLive(item) {
      await markLongLive(item);
      this.$message.success("change successfully");
    },
    getColumnIndex(item, metricsList) {
      const list = metricsList.filter(m => {
        return m.name == item.name
      })
      const model = list.shift()
      return model?.value
    },
    getColumnDada(index, item, row) {
      let ss = "";
      if (index) {
        console.log("row = ", row);
        console.log("index = ", index);
        console.log("item = ", item);

        const mm = this.dataList[index];
        for (const m of mm.metricsList) {
          if (item.name == m.name) {
            ss = m.value;
          }
        }
      }
      return ss;
    },
    inputChange() {
      console.log("inputChange....");
    },
    pushPage(m) {
      for (const dm of this.dataList) {
        dm.titleColor = ''
      }
      m.titleColor = '#000'
      console.log("pushPage = ", m);
      const routeData = this.$router.resolve({
        name: "Trial",
        params: { id: m.trialid },
      });
      window.open(routeData.href, "_blank");
    },
    getStatusMap(status) {
      let statusTitle = "";
      let bgColor = ''
      if (status == RunnerStatus.DONE) {
        statusTitle = "Done";
        bgColor = "#EEFCE8";
      } else if (status == RunnerStatus.ERROR) {
        statusTitle = "Error";
        bgColor = "#FFEBEB";
      } else if (status == RunnerStatus.RUNNING) {
        statusTitle = "Running";
        bgColor = "#DBECFF";
      } else if (status == RunnerStatus.WAITING) {
        statusTitle = "Waiting";
        bgColor = "#FFF8E0";
      } else if (status == RunnerStatus.TIMEOUT) {
        statusTitle = "Timeout";
        bgColor = "#E9E1FC";
      } else if (status == RunnerStatus.CANCELED) {
        statusTitle = "Cancelled";
        bgColor = "#E9E1FC";
      }
      return { title: statusTitle, bgColor: bgColor };
    },
    async getTrailListData() {
      const newList = []
      const resourcesObj = await queryResourcesList({type:ResourceType.TRIAL, pageNumber: this.sheetPage.pageNumber - 1, pageSize: this.sheetPage.pageSize});
      const resourcesList = resourcesObj.resourcesList
      this.sheetPage.totalCount = resourcesObj.totalcount
      const href = window.location.href.split("/benchmark").shift();
      for (const item of resourcesList) {
        const trialid = item.resourceid;
        const trail = href + "/benchmark/trial/" + item.resourceid;
        const createDate = moment(
          (item.creationtime?.seconds + item.creationtime?.nanos / Math.pow(10, 9)) * 1000
        ).format("YYYY-MM-DD HH:mm:ss");
        const status = this.getStatusMap(item.runnerstatus).title;
        const retention = item.retention == 0 ? "ShortLived" : "LongLived";
        const disabled = this.trialsList.some((m) => {
          return m.trialid == trialid;
        });
        const isSelected = disabled;
        let title = "";
        let describle = "";
        for (const map of item.annotationsMap) {
          if (map[0] == "title") {
            title = map[1];
          } else if (map[0] == "description") {
            describle = map[1];
          }
        }
        const model = {
          trail,
          createDate,
          status,
          retention,
          isSelected,
          disabled,
          title,
          describle,
          trialid,
        };
        newList.push(model);
      }
      this.allSelectDataList.push(
        {
          key: this.sheetPage.pageNumber,
          list: newList,
        }
      )
    },
    //错位
    tableLayout() {
      this.$nextTick(() => {
        this.$refs.dragTable.doLayout();
      });
    },

    analysisSheets(sheets) {
      const calculationShettTime = ((start, finish, index) => {
        const createTime = start
        const finishTime = finish
        if (index == 0) {
          this.minTime = createTime
          this.maxTime = finishTime
        }
        if (createTime < this.minTime) {
          this.minTime = createTime
        }
        if (finishTime > this.maxTime) {
          this.maxTime = finishTime
        }
      });
      const calculationSheetStatus = ((runStatus) => {
        const statusM = this.getStatusMap(runStatus);
        if (runStatus == RunnerStatus.RUNNING) {
          this.sheetStatusModel.hasRunning = true;
          this.showCancel = true;
          this.sheetStatusModel.runState = RunnerStatus.RUNNING
        } else if (runStatus == RunnerStatus.WAITING) {
          this.showCancel = true;
        } else if (runStatus == RunnerStatus.CANCELED) {
          this.sheetStatusModel.hasCancel = true;
        }
        const m = {
          name: "Status",
          field: "Status",
          value: statusM.title,
          bgColor: statusM.bgColor,
          sortValue: runStatus,
          source: 1,
        };
        return m
      })
      const trialBgColor = (color => {
        let trialColor = ''
        if (color == "green") {
          trialColor = '#aef191'
        } else if (color == "yellow") {
          trialColor = '#e8e859'
        } else if (color == "purple") {
          trialColor = '#e2d4fb'
        } else if (color == "red") {
          trialColor = '#ff8989'
        }
        return trialColor
      })
      

      let maxWidth = 0
      const leftNameList = []
      for (const key in sheets) {
        const keyIndex = parseInt(key) + 1
        const sheetM = sheets[key] 
        const leftListArr = sheetM.name.split("-")
        sheetM.list = leftListArr
        for (const nameIndex in leftListArr) {
          const cName = leftListArr[nameIndex]
          if (leftNameList.length > nameIndex) {
            const h = leftNameList[nameIndex].list.some(m => {
              return m.name == cName
            })
            if (!h) {
              leftNameList[nameIndex].list.push({name: cName, selected: false})
            }
          } else {
            leftNameList.push({selected: false, list: [{name: cName, selected: false}]})
          }
        }
        const str = `${keyIndex} ${sheetM?.name}`;
        const flexWidth = getStrWidthBySpan(str, 13, 500)
        if (flexWidth >= maxWidth) {
          maxWidth = flexWidth;
        }
        const createTime = (sheetM.trialinfo?.creationtime?.seconds + sheetM.trialinfo?.creationtime?.nanos / Math.pow(10, 9)) * 1000
        const finishTime = (sheetM.trialinfo?.finishtime?.seconds + sheetM.trialinfo?.finishtime?.nanos / Math.pow(10, 9)) * 1000
        calculationShettTime(createTime, finishTime, key)
        sheetM.isSelected = false
        sheetM.runnerStatus = sheetM.trialinfo?.status
        sheetM?.metricsList?.map((m) => {
          m.source = 2;
          if (m.value) {
            m.sortValue = m.value
          } else {
            m.sortValue = "/"
            m.value = m.sortValue
          }
          m.trialColor = trialBgColor(m.color)

          const arr = m.name.split(".")
          m.list = arr
          const name = m.name;
          sheetM[name] = m
        });
        const m = calculationSheetStatus(sheetM.runnerStatus)
        let durationTotalTime = '/'
        
        if (finishTime >= createTime) {
          durationTotalTime = finishTime/1000 - createTime/1000 
        }
        const time = formatTimeTo2HMS(durationTotalTime)
        let durationV
        if (finishTime > createTime) {
          durationV = finishTime - createTime
        } else {
          durationV = "/"
        }
        const durationM = {
          name: "Duration",
          field: "Duration",
          value: `${time}`,
          bgColor: '#fff',
          sortValue: durationV,
          source: 1,
        };
        sheetM.metricsList.unshift(durationM);
        sheetM[durationM.name] = durationM
        sheetM.metricsList.unshift(m);
        const statusName = m.name
        sheetM[statusName] = m
        // for (const m of sheetM.metricsList) {
        //   const name = m.name;
        //   sheetM[name] = m
        // }
      }
      this.leftCaseTitleList = leftNameList
      maxWidth = maxWidth > 150 ? maxWidth : 150;
      let w = 75;
      if (!this.isCanEdite) {
        w = 30;
      }
      maxWidth = maxWidth + w + 5
      this.trialMaxWidth = maxWidth > 390 ? 390 : maxWidth
    },

    async loadMore(rowList) {
      this.loading = true;
      let pageTrials = await getQueryMetricsBySheet(this.$route.params.id);
      if (pageTrials?.length == 0 && rowList?.length > 0) {
        for (const row of rowList) {
          const statusData = await getQueryStatus(row.trialid, ResourceType.TRIAL);
          const sheetM = {
            trialinfo: {}
          }
          sheetM.trialid = row.trialid
          sheetM.name = row.name
          sheetM.trialinfo.creationtime = statusData.run?.creationtime
          sheetM.trialinfo.finishtime = statusData.run?.finishtime
          sheetM.trialinfo.status = statusData.run?.status
          sheetM.runnerStatus = sheetM.trialinfo?.status
          sheetM.metricsList = []
          pageTrials.push(sheetM)
        }
      }
      this.analysisSheets(pageTrials)
      // this.flexRowWidth(pageTrials)
      let maxHeight = 0
      this.dataList = pageTrials
      this.originDataList = [...pageTrials]//JSON.parse(JSON.stringify(this.dataList))
      this.searchDataList = [...pageTrials]//JSON.parse(JSON.stringify(this.dataList))
      const caseTitleList = []
      for (const index in this.originColumnsTitleList) {
        const item = this.originColumnsTitleList[index];
        //此处循环耗时
        const valueW = this.flexColumnWidth(item, index)
        const tList = item.name.split(".")        
        let maxTW = 80
        let colH = 0
        if (index > 1) {
          const tcList = []
          for (const key in tList) {
            const s = tList[key]
            if (s) {
              tcList.push(s)
              const tH = 17//getFontHeight(s, 13, 700) + 1
              colH += tH
              const tW = getStrWidthBySpan(`.${s}`, 13, 700) + 16 + 5
              const rtW = 10//getStrWidthBySpan(s, 12, 400)
              let leftBtnWidth = rtW //+ 10
              let showTip = false
              if (leftBtnWidth > MAX_LEFT_BTN_WIDTH) {
                leftBtnWidth = MAX_LEFT_BTN_WIDTH
                showTip = true
              } else if (leftBtnWidth <= MIN_LEFT_BTN_WIDTH) {
                leftBtnWidth = MIN_LEFT_BTN_WIDTH
              }
              if (caseTitleList.length > key) {
                const li = caseTitleList[key]
                const isHave = li.some(model => {
                  return model?.name == s
                })
                if(!isHave) {
                  const model = {
                    name: s,
                    selected: false,
                    width: leftBtnWidth,
                    showTip: showTip
                  }
                  li.push(model)
                }
              } else {
                const model = {
                  name: s,
                  selected: false,
                  width: leftBtnWidth,
                  showTip: showTip
                }
                const li = [model]
                caseTitleList.push(li)
              }
              if (tW > maxTW) {
                maxTW = tW
              }
            } 
          }
          item.list = tcList
          if (tcList?.length == tList?.length) {
            item.showName = item.list.join("\n.")
          } else {
            item.showName = item.list.join("\n.") + '.'
          }
          item.width = (maxTW > valueW ? maxTW : valueW) 
        } else {
          item.width = valueW
          item.list = item.name.split(".")
        }
        
        if (colH > maxHeight) {
          maxHeight = colH 
        }
      }
      maxHeight = maxHeight > 60 ? maxHeight : 60
      this.maxHeaderLineH = maxHeight + 20 + 'px'

      let leftMaxTitleWidth = 0
      this.caseTitleList = []
      for (const titleList of caseTitleList) {
        for (const titleItem of titleList) {
          const width = titleItem.width
          if (width >= leftMaxTitleWidth) {
            leftMaxTitleWidth = width
          }
        }
        const model = {
          isSelected: false,
          list: titleList
        }
        this.caseTitleList.push(model)
      }
      if (leftMaxTitleWidth <= 80) {
        leftMaxTitleWidth = 80
      }
      this.rightConfig.leftWidth =  2*90 + 'px'//leftMaxTitleWidth + 90 + 'px'
      this.loading = false
    },

    async initData() {
      const param = this.$route.params;
      const id = param.id;
      this.resourceId = id;
      this.loading = true;
      this.dataList = []
    
      const statusData = await getQueryStatus(id, ResourceType.SHEET);
      if (statusData.error) {
        return;
      }
      let title = "";
      if (statusData.sheet?.annotationsMap) {
        const mapList = [...statusData.sheet?.annotationsMap];
        title = this.$parent.$parent.getTitle(mapList);
      }
      document.title = `aqua.sheet${title}`;
      statusData.sheet?.rowsList.map((m) => {
        m.isSelected = false;
      });
      this.originTrialsList = statusData.sheet?.rowsList
      this.trialsList = this.originTrialsList
      // this.tableH = 51 * this.trialsList.length + 46 + 15
      statusData.sheet?.columnsList.map((m) => {
        m.bgColor = "#ffffff";
        m.source = 2;
      });
      
      const firstColumnsTitleList = statusData.sheet?.columnsList;
      const durationModel = {
        name: "Duration",
        field: "Duration",
        showName: "Duration",
        bgColor: "#ffffff",
        source: 1,
      };
      firstColumnsTitleList.unshift(durationModel);

      const statusModel = {
        name: "Status",
        field: "Status",
        showName: "Status",
        bgColor: "#ffffff",
        source: 1,
      };
      firstColumnsTitleList.unshift(statusModel);

      this.showCancel = false;
      this.maxTime = null;
      this.minTime = null;
  
      // this.loading = false;
      const creationtime = statusData.sheet.creationtime;
      const createTime = moment(
        (creationtime.seconds + creationtime.nanos / Math.pow(10, 9)) * 1000
      ).format("YYYY-MM-DD HH:mm:ss");
      const committer = statusData.sheet.committer;
      const user = await getPageUserByUserId(committer);
      this.userModel.name = user.user?.nickname;
      this.userModel.time = createTime;
      this.userModel.type = statusData.sheet?.retention;
      const tagList = []
      if (statusData.sheet?.tagsList?.length > 0) {
        this.checkList.forEach(m => {
          if (statusData.sheet?.tagsList.includes(m.title)) {
            m.selected = true
            tagList.push(m)
          }
        })
      }
      this.isCanEdite = localStorage.getItem("userId") == committer;
      if (!this.isCanEdite) {
        this.showCancel = false;
        this.checkList = tagList
      }      
     
      this.annotationList = [];
      for (const map of statusData.sheet?.annotationsMap) {
        const item = {
          keyWord: map[0],
          keyValue: map[1],
          isSelected: false,
          img: require("@/assets/data-normal-icon.png"),
        };
        this.annotationList.push(item);
      }
      this.originColumnsTitleList = firstColumnsTitleList
      await this.loadMore(statusData?.sheet?.rowsList)
      const newColumnsTitleList = [...this.originColumnsTitleList]//JSON.parse(JSON.stringify(this.originColumnsTitleList))
      this.scrollColumnsTitleList = newColumnsTitleList
      if (newColumnsTitleList.length > COLUMNS_LEN) {
        this.columnsTitleList = newColumnsTitleList.slice(0, COLUMNS_LEN)
      } else {
        this.columnsTitleList = newColumnsTitleList
      }
      if (this.minTime) {
        this.sheetStatusModel.start = moment(this.minTime).format("YYYY-MM-DD HH:mm:ss");
        this.showStatusBox = true;
      }
      if (this.minTime && this.maxTime > 0) {
        const durationTotalTime = (this.maxTime - this.minTime) / 1000;
        this.sheetStatusModel.time = formatTimeToHMS(durationTotalTime);
        const finishTime = moment(this.maxTime).format("YYYY-MM-DD HH:mm:ss");
        this.sheetStatusModel.finish = finishTime;
      }
      if (this.sheetStatusModel.hasRunning) {
        // this.sheetStatusModel.currentState = RunnerStatus.WAITING
        if (this.sheetStatusModel.runState == RunnerStatus.RUNNING) {
          this.sheetStatusModel.currentState = RunnerStatus.RUNNING
        }
      } else if (this.sheetStatusModel.hasCancel) {
        this.sheetStatusModel.currentState = RunnerStatus.CANCELED
      }
    },
    loadBgLayout() {
      const _this = this
      this.$nextTick(() => {
        // const clientWidth = document.body.clientWidth - 20
        const bgWidth = _this.$refs.refBg?.clientWidth
        _this.leftConfig.bgShow = bgWidth >= 550
        _this.rightConfig.bgShow = bgWidth >= 550
        // let wid = 0
        // if (_this.rightConfig.leftWidth.split('px')?.length > 0) {
        //   wid = parseFloat(_this.rightConfig.leftWidth.split('px')[0]) + 10
        // }
        // const left = (clientWidth - bgWidth) / 2 + 10
        // if (_this.rightConfig.isShow) {
        //   if (wid > left) {
        //     _this.rightConfig.bgLeft = wid 
        //   } else {
        //     _this.rightConfig.bgLeft = left 
        //   }
        // } else {
        //   _this.rightConfig.bgLeft = left 
        // }
        // _this.rightConfig.bgMarginLeft = _this.rightConfig.bgLeft + 'px'
        _this.getTableHeight()
      })
    },
  },
  async created() {
    await this.initData();
    this.tableLayout();
    if (this.columnsTitleList.length > 2) {
      this.rightConfig.isShow = true
    }
    if (this.trialsList.length >= 2) {
      this.leftConfig.isShow = true
    }
    this.loadBgLayout()
    this.showLeftIcon = this.trialsList.length >= 2
    const _this = this
    this.$nextTick(() => {
      const dom = this.$refs.dragTable.$refs.scrollBarRef.wrapRef//bodyWrapper;
      dom.addEventListener('scroll',()=>{
        const tableWidth = dom.offsetWidth
        const scrollLeft = dom.scrollLeft
        const scrollWidth = dom.scrollWidth
        if(scrollLeft != 0 && (Math.round(scrollWidth-tableWidth) <= Math.round(scrollLeft))){
          if (_this.columnsTitleList.length < _this.scrollColumnsTitleList.length) {
            const startIndex = _this.columnsTitleList.length
            const endIndex = startIndex + 8
            const scollList = _this.scrollColumnsTitleList.slice(startIndex, endIndex)
            _this.columnsTitleList = _this.columnsTitleList.concat(scollList)
          }          
        } 
      }, true) 
    })
  },
};
</script>
<style lang='less' scoped>
.sheet {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  padding: 0px 10px;
}

.bg {
  margin: 0 auto;
  min-width: 1200px;
  width: calc(100% - 850px);
  max-width: 2000px;
}

@media screen and (max-width: 1800px) {
  .bg {
    margin: 0 auto;
    width: calc(100% - 380px);
    min-width: 549px;//700px;
  }
}

.tool-tip {
  position: absolute;
  right: 40px;
  top: 50px;
  z-index: 999;
  background-color: #3333;
  color: #fff;
}

.check_bg_box {
  margin-left: 30px; 
  display: flex;
  flex-direction: row;
  .check-box {
    margin-left: 0px; 
  }
}

.publishBtn {
  display: flex;
  background-color: #0052d9;
  color: #ffffff;
  font-size: 13px;
  border: 0;
  min-height: 34px;
  height: 34px;
  border-radius: 18px;
  align-items: center;
  justify-content: center;
  margin-left: 60px;
  width: 110px;
}

.delete-trial-icon {
  position: absolute;
  height: 35px;
  width: 35px;
  top: 90px;
  left: 300px;
  z-index: 99;
  object-fit: contain;
  cursor: pointer;
}

.add-line-bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 15px;
  left: 0px;
  z-index: 99;
  cursor: pointer;

  img {
    height: 35px;
    width: 35px;
    object-fit: contain;
  }

  .add-line {
    margin-top: 10px;
    height: 405px;
    width: 3px;
    background-color: #0052d9;
  }
}

.info-bootom-box {
  margin-top: 15px;
  display: flex;
  height: 13px;
  align-items: center;
  cursor: pointer;
  width: 100%;
  background-color: #fff;
  height: 50px;
  justify-content: center;

  .info-bootom-title {
    color: #00baad;
    font-size: 12px;
  }
  img {
    margin-left: 5px;
  }
}



.show-right-content-box {
  position: fixed;
  right: 15px;
  top: 90px;
  z-index: 999;
  img {
    height:20px;
    width:20px;
    cursor: pointer;
  }
}

.show-left-content-box {
  position: fixed;
  left: 15px;
  top: 90px;
  z-index: 999;
  img {
    height:20px;
    width:20px;
    cursor: pointer;
  }
}

.base-content-box {
  height: 100vh;//calc(100vh - 180px);
  margin-left: 0px;
}

.right-content-box {
  width: 200px;
  height: calc(100vh - 180px);
  right: 10px;
  background-color: #fff;
  position: fixed;
  top: 130px;
  overflow-x: hidden;
	overflow-y: scroll;
  z-index: 999;
  border-radius: 6px;
  padding:0px;

  .left-box {
    margin-top: 10px;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #b9b9b9;
    position: relative;
    padding: 15px 2px 5px 2px;
    .left-btn {
      margin: 2px;
      min-width: 60px;
      // max-width: 100%;
      padding: 1px 5px;
      font-size: 12px;
      font-weight: 400;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .resetBtn {
      position: absolute;
      top: 1px;
      right: 3px;
      font-size: 13px;
      background-color: rgba(#fff, #fff, #fff, 0);
      cursor: pointer;
      color: #0052d9;
      height: 14px;
      width: 14px;
      img {
        object-fit: contain;
        height: 11px;
        width: 11px;
      }
    }
  }

  .left-confirm-btn {
    margin-top: 20px;
    width: 120px;
  }
}

.left-content-box { 
  left: 10px;
}

.tableBg {
  // height: 100%;
  padding: 0px 0px 28px 0px;
  margin-top: 50px;
  position: relative;
}

.cancel-btn-box {
  margin-top: 50px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;

  .cancelBtn {
    color: #fff;
    font-size: 13px;
    height: 40px;
    width: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0052d9;
    border-radius: 20px;
  }
}

.status-box {
  font-weight: 18px;
  width: 100%;
  // color: #383838;
  height: 60px;
  display: flex;
  align-items: center;
  margin-top: 25px;
  padding: 10px 0px;
  background-color: #ffffff;

  .status-time {
    margin-left: 35px;
    width: 300px;
    background-color: #ecf2fe;
  }

  .status-start {
    width: calc((100% - 4 * 45px - 380px - 180px) / 2);
    margin-left: 45px;
    background-color: #f5f5f5;
  }

  .cancel-status-start {
    width: calc((100% - 4 * 45px - 380px - 280px) / 2);
    margin-left: 45px;
    background-color: #f5f5f5;
  }

  .status-line {
    // opacity: 1;
    height: 1.5px;
    width: 31px;
    background-color: #b9b9b9;
    margin-left: 10px;
  }

  //335 + 45
  .status-finish {
    width: calc((100% - 4 * 45px - 380px - 180px) / 2);
    margin-left: 10px;
    background-color: #f5f5f5;
  }

  .cancel-status-finish {
    width: calc((100% - 4 * 45px - 380px - 280px) / 2);
    margin-left: 10px;
    background-color: #f5f5f5;
  }

  .status-font {
    height: 100%;
    display: flex;
    align-items: center;
    text-align: left;
    padding-left: 8px;
    font-size: 13px;
    color: #383838;
    border-radius: 3px;
    font-weight: 400;
  }

  .status-title {
    width: 180px;
    height: 100%;
    background-color: #eefce8;
    margin-left: 45px;
    border-radius: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #383838;
    font-weight: 700;
  }

  .cancelBtn {
    margin-left: 30px;
    color: #fff;
    font-size: 13px;
    height: 40px;
    width: 115px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0052d9;
    border-radius: 20px;
  }
}

.table {
  border: 1px solid #999999;

  .header-bg {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin: 0px 8px;
    // height: 45px;
    // min-width: 100px;

    .header-input {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      :deep(.el-input__inner) {
        border: 0;
        background-color: #f6f6f6;
        width: 100%;
        text-align: center;
      }
    }

    .header-bottom {
      width: 100%;
      position: absolute;
      bottom: 0px;
      height: 12px;
      cursor: pointer;
    }

    .line {
      position: absolute;
      height: 100%;
      width: 3px;
      right: 0px;
      cursor: pointer;
    }

    .add-head-clounm-icon {
      position: absolute;
      top: -px;
      right: 0px;
      height: 25px;
      width: 25px;
      object-fit: contain;
      z-index: 999;
    }
  }

  .header-box {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
  }

  .header-box-top {
    display: flex;
    flex-direction: row;
    width: 100%;
    // height: 22px;//100%;
    align-items: center;
    height: calc(100% - 30px);
  }

  .header-box-bottom {
    margin-top: 8px;
    width: 100%;
    position: absolute;
    bottom: 1px;
  }

  .header-trial-img {
    margin-left: 10px;
    height: 20px;
    width: 20px;
    cursor: pointer;
    object-fit: contain;
  }

  .header-title {
    color: #000000;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    line-height: 17px;
    white-space: pre-wrap;
  }

  .header-trial {
    height: 100%;
    line-height: 100%;
    margin-left: 25px;
    cursor: default;
    display: flex;
    // align-items: center;
  }

  .content-bg {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    // min-height: 50px;
    height: 50px;

    .table-content {
      font-size: 13px;
      font-weight: 400;
      word-wrap:break-word;
      // overflow: hidden;
      // text-overflow: ellipsis;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .table-status {
      border-radius: 20px;
      min-height: 35px;
      font-size: 13px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100px;
      color: #383838;
    }

    .line {
      position: absolute;
      height: 100%;
      width: 3px;
      right: 0px;
      cursor: pointer;
    }
  }

  .dur-content-bg {
    justify-content: flex-end;
    padding-right: 8px;
  }

  .trial-bg {
    display: flex;
    align-items: center;
    position: relative;
    .trial-no {
      display: flex;
      text-align: left;
      font-size: 13px;
      font-weight: 500;
      white-space: nowrap;
      color: #999999; //#0050b3;
      margin-left: 15px;
      margin-right: 13px;
    }

    .table-trial {
      // min-height: 50px;
      height: 50px;
      cursor: pointer;
      display: flex;
      align-items: center;
      text-align: left;
      font-size: 13px;
      font-weight: 500;
      color: #0050b3;
      word-wrap: break-word;
      padding-right: 2px;
    }
  }
}

.bottom-loading {
  // background-color: red;
  margin-top: 0px;
}

:deep(.el-table .cell) {
  padding: 0px !important;
}

:deep(.el-table td) {
  padding: 0px !important;
}

:deep(.el-table th) {
  padding: 0px !important;
  user-select: initial !important;
}

:deep(.el-table tr) {
  padding: 0px !important;
}

:deep(.el-button) {
  min-height: 36px !important;
  white-space: pre-wrap !important;
  word-break:break-all !important;
}

:deep(.el-checkbox) {
  margin-right: 20px !important;
}

/* 隐藏父级节点选框 */
// :deep(.el-tree .el-tree-node .is-leaf + .el-checkbox .el-checkbox__inner) {
//   display: inline-block;
// }
// :deep(.el-tree .el-tree-node .el-checkbox .el-checkbox__inner) {
//   display: none;
// }

:deep(.el-tree .el-tree-node .is-leaf + .el-tree-node__label) {
    font-size: 13px !important;
  // font-weight: bold;
}

:deep(.el-tree .el-tree-node  .el-tree-node__label) {
  font-size: 13px !important;
  font-weight: 500 !important;
  // font-weight: 400px !important;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.05s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from {
  transform: translateX(20px);
}
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.top-fade-enter-active {
  transition: all 0.05s ease-out;
}

.top-fade-leave-active {
  transition: all 0.05s cubic-bezier(1, 0.5, 0.8, 1);
}

.top-fade-enter-from {
  transform: translateY(-10px);
}
.top-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

</style>